// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"DropdownMenu_dropdownMenu__4-Y2f","dropdownItem":"DropdownMenu_dropdownItem__gYVxM","settingsContainer":"DropdownMenu_settingsContainer__MaR+f"};